/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Point_InspectionsInputs */



/**
* | output |
* | --- |
* | "Carrying out SIRE 2.0, RISQ, OVID and BIRE inspections" |
*
* @param {Team_Point_InspectionsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const team_point_inspections = /** @type {((inputs?: Team_Point_InspectionsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Point_InspectionsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("开展 SIRE 2.0、RISQ、OVID 和 BIRE 检查")
	return /** @type {LocalizedString} */ ("Carrying out SIRE 2.0, RISQ, OVID and BIRE inspections")
});